











































import { Vue, Component } from 'vue-property-decorator'

const AppProps = Vue.extend({
  props: {}
})
@Component({})
export default class Hello extends AppProps {
  frontPageTopics = [
    {
      id: 0,
      header: 'Hvem er Camp Hest?',
      desc: 'Først og fremmest: den heste camp på Roskilde! Du kan kende os på vores orange t-shirts med hesteslogans og vores hestekostumer. Vi elsker at have camp i Clean Out Loud og går efter at være både den reneste camp og den camp, der samler flest dåsesplitter.'
    }
  ];

  range (start: number, end: number) {
    return Array(end).fill(start).map((x, y) => x + y)
  }

  getImage (imageName: string) {
    return !imageName ? require('../assets/heste_mates/pony_free.png') : require('../assets/heste_fest/' + imageName)
  }
}
